import classNames from 'classnames';
import PropTypes from 'prop-types';

import * as AppPropTypes from '../../lib/PropTypes';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/partials/user-letter.module.scss';

const propTypes = {
    user: AppPropTypes.user.isRequired,
    withName: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    withName: false,
    className: null,
};

function UserLetter({ user, withName, className }) {
    const themeClassName = useThemeClassName(styles);
    const { letter = null, name = null } = user || {};
    const char = letter || 'J';
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [themeClassName]: themeClassName !== null,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.letter}>{char}</div>
            {withName ? <div className={styles.name}>{name || null}</div> : null}
        </div>
    );
}

UserLetter.propTypes = propTypes;
UserLetter.defaultProps = defaultProps;

export default UserLetter;
